<template>
  <!--    Register in Shaparak Modal-->
  <b-modal
    ref="my-modal"
    :title="$translate('submitNationalCode')"
    header-class="justify-content-center position-relative"
    centered
    hide-footer
    v-model="visibility"
  >
    <div class="d-block direction-rtl">
      <b-row>
        <b-col cols="12" class="error-detail-text"
          >{{ $translate("ToUseThisSwitchYouNeedToEnterOwnerNationalCode") }}
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-center align-items-center midnight-blue-text font-size-small pb-1 font-weight-bold"
          >{{ $translate("nationalCode") }}
        </b-col>
      </b-row>
      <b-row class="direction-ltr m-0 pb-2">
        <b-form-input
          id="otp-code"
          :placeholder="$translate('enterTheOwnerNationalCode')"
          class="form-control mx-1"
          required
          v-model="nationalCode"
          v-mask="'##########'"
          :state="nationalCodeValidation"
        ></b-form-input>
        <transition
          name="animate__fadeIn"
          enter-active-class="animate__animated animate__fadeIn"
          leave-active-class="animate__animated animate__fadeOut"
          appear
        >
          <b-form-invalid-feedback
            class="font-size-xs direction-rtl"
            id="otp-code-feedback"
            v-if="nationalCode.length > 6"
          >
            {{ $translate("maximum10CharactersAllowed") }}
          </b-form-invalid-feedback>
        </transition>
      </b-row>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <button class="modal-button" @click="submitInfo">
            <span>{{ $translate("submit") }}</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
  <!--    Register in Shaparak Modal-->
</template>

<script>
// import alertHelper from "@/helper/AlertHelper";

export default {
  name: "ShetabNationalCodeModal",
  props: {
    visibility: Boolean,
  },

  data() {
    return {
      nationalCode: "",
    };
  },
  computed: {
    nationalCodeValidation() {
      return this.nationalCode.length === 10;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submitInfo() {
      this.$emit("submitInfo", this.nationalCode);
      this.closeModal();
    },
    //Submit Information
  },
};
</script>

<style scoped>
.modal-button {
  width: 50%;
  padding: 5px;
  margin-top: 20px;
  color: #ffffff;
  border-radius: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: var(--dodger-blue);
  border: none;
}

.error-detail-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--midnight-blue);
  font-size: 0.8rem;
  text-align: center;
  padding-bottom: 15px;
}
</style>
